export const photoModalConstants = {
  WIDTH: "80rem",
  TITLE: "Material Pictures",
  SUBMIT_TXT: "Upload",
  PICTURES_LABEL: "Picture Gallery",
  DOWNLOAD_ALL: "Download All",
  BUTTON_CLASSNAME: "downloadButtonStyle",
  DELETE_SUCCESS: "Image Deleted",
  UPLOAD_SUCCESS: "Image(s) uploaded successfully",
  DOWNLOAD_ALT: "Click to Download",
  DELETE_ALT: "Click to Delete",
  NO_IMAGES: "No Images",
  UPLOAD_EMPTY_ERROR: "Please Upload images to update",
};

export const DraggerConstants = {
  UPLOAD_PRIMARY_TXT: "Click or drag file to this area to upload",
  UPLOAD_HINT: "Max file size is 6MB",
  DEFAULT_SHEET_STATE: "Pending",
  FILE_UPLOAD_SUCCESS_TXT: "Upload Completed!",
  DRAGGER_LABEL: "Upload Picture",
};

export const FileUploadConstants = {
  DUPLICATE_WARNING: (fileName: string) =>
    `${fileName} is already uploaded. Do you want to upload it again?`,
  UPLOAD_SUCCESS: (fileName: string) => `${fileName} uploaded successfully`,
  UPLOAD_FAILED: (fileName: string) => `${fileName} upload failed`,
  DUPLICATE_TITLE: "Duplicate File",
  FILE_SIZE_WARNING: "File must be less than 6MB.",
  FILE_TYPE_WARNING_2: "Only Image files are allowed.",
  FILE_TYPE_WARNING: "Only Image files are allowed.",
  PROGRESS_COLOR: "#87d068",
};
